import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import { Editor } from 'slate';

var MarkUtils = function MarkUtils(editor) {
  var _this = this;

  _classCallCheck(this, MarkUtils);

  this.getActiveMarks = function () {
    var marks = Editor.marks(_this.editor);
    return marks;
  };

  this.setMark = function (type) {
    _this.editor.exec({
      type: 'format_text',
      properties: _defineProperty({}, type, true)
    });
  };

  this.editor = editor;
};

export default MarkUtils;